import { Component, OnInit } from "@angular/core";
import {
  MatTableDataSource,
} from "@angular/material";
import { AppService } from "src/_services/app.service";
import { Router, ActivatedRoute } from "@angular/router";
import * as moment from "moment";

interface FailureReasonCount {
  reason: string;
  count: number;
}

interface EventDecisionSummary {
  eventId: string;
  eventName: string;
  openDate: number; // unixmilli
  successCount: number;
  failureCount: number;
  failureReasons: FailureReasonCount[];
}

@Component({
  selector: "app-event-arbitrage-decisions",
  templateUrl: "./event-arbitrage-decisions.component.html",
  styleUrls: ["./event-arbitrage-decisions.component.scss"],
})
export class EventArbitrageDecisionsComponent implements OnInit {
  selected: any = { startDate: null, endDate: null };
  userInfo: any = JSON.parse(sessionStorage.getItem("currentUser"));
  eventDecisionsList = new MatTableDataSource<EventDecisionSummary>([]);
  displayedColumns: string[] = [
    "openDate",
    "eventName",
    "successCount",
    "failureCount",
  ];
  loading: boolean = false;
  expandedElement: EventDecisionSummary | null = null;
  sportId: string = "";
  sportName: string = "";

  constructor(
    private appService: AppService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.sportId = params.sportId || "";
      this.sportName = params.sportName || "";

      if (params.startTime && params.endTime) {
        this.selected = {
          startDate: params.startTime !== "0" ? new Date(params.startTime * 1000) : null,
          endDate: params.endTime !== "0" ? new Date(params.endTime * 1000) : null,
        };
      } else {
        // Default to yesterday
        this.selected = {
          startDate: moment().subtract(1, "days").startOf("day").toDate(),
          endDate: moment().subtract(1, "days").endOf("day").toDate(),
        };
      }

      if (this.sportId && this.selected.startDate && this.selected.endDate) {
        this.getEventDecisions();
      }
    });
  }

  getEventDecisions = () => {
    if (!this.selected.startDate || !this.selected.endDate || !this.sportId) {
      this.appService.openErrorBar("Missing required parameters");
      return;
    }

    this.loading = true;
    const filters = {
      sportId: this.sportId,
      startTime: Math.floor(new Date(this.selected.startDate).getTime() / 1000),
      endTime: Math.floor(new Date(this.selected.endDate).getTime() / 1000),
    };

    this.appService.getEventLevelArbitrageDecisions(filters).subscribe(
      (res) => {
        this.loading = false;
        if (res.status === "RS_OK") {
          const data = res.data || res.eventDecisions || res.decisions || [];
          this.eventDecisionsList = new MatTableDataSource<EventDecisionSummary>(data);
        } else if (res.errorDescription === "Invalid Token!") {
          this.appService.openErrorBar(res.errorDescription);
          sessionStorage.clear();
          this.router.navigateByUrl("/login");
        } else {
          this.appService.openErrorBar(
            res.errorDescription || "Failed to fetch event decisions"
          );
        }
      },
      (error) => {
        this.loading = false;
        const errorMessage = (error.error && error.error.errorDescription)
          ? error.error.errorDescription
          : "Error fetching event decisions";
        this.appService.openErrorBar(errorMessage);
      }
    );
  };

  toggleRow(element: EventDecisionSummary) {
    this.expandedElement = this.expandedElement === element ? null : element;
  }

  isExpanded(element: EventDecisionSummary): boolean {
    return this.expandedElement === element;
  }

  formatOpenDate(openDate: number): string {
    if (!openDate) return "";
    // openDate is in unixmilli, convert to moment and format
    return moment(openDate).format("DD-MM-YYYY HH:mm");
  }

  goBack() {
    this.router.navigate(["/administration/sport-arbitrage-decisions"], {
      queryParams: {
        startTime: this.selected.startDate
          ? Math.floor(new Date(this.selected.startDate).getTime() / 1000)
          : 0,
        endTime: this.selected.endDate
          ? Math.floor(new Date(this.selected.endDate).getTime() / 1000)
          : 0,
      },
    });
  }

  navigateToDecisionsDetail(element: EventDecisionSummary) {
    if (!element || !element.eventId) {
      return;
    }

    const queryParams = {
      eventId: element.eventId,
      eventName: element.eventName || element.eventId,
      sportId: this.sportId,
      sportName: this.sportName,
      startTime: this.selected.startDate
        ? Math.floor(new Date(this.selected.startDate).getTime() / 1000)
        : 0,
      endTime: this.selected.endDate
        ? Math.floor(new Date(this.selected.endDate).getTime() / 1000)
        : 0,
    };

    this.router.navigate(["/administration/arbitrage-decisions-detail"], {
      queryParams: queryParams,
    });
  }
}

